import { videoDict, comicsDict, quizDict, SurveyDict } from './categoryData';
import MehrOnboarding from './MehrOnboarding';
import ProjektOnboarding from './ProjektOnboarding';
import HighlightZone from './renderHighlightZones';
import StartOnboarding from './StartOnboarding';
import Publications from '../Publications/Publications';

export const categoriesData = (translator) => {
    return {
        [translator("navigationCat1")]: <StartOnboarding/>,
        [translator("navigationCat2")]: <HighlightZone data={videoDict} odd/>,
        [translator("navigationCat3")]: <HighlightZone data={comicsDict}/>,
        [translator("navigationCat4")]: <HighlightZone data={quizDict} odd/>,
        [translator("navigationCat5")]: <HighlightZone data={SurveyDict}/>,
        [translator("navigationCat11")]: <ProjektOnboarding/>,
        [translator("navigationCat13")]: <Publications/>,
        [translator("navigationCat10")]: <MehrOnboarding/>

    }
}